/**
 * Devnet faucet base grant size, in whole USD display units — the fallback the
 * backend mints when a claim doesn't request a specific amount. The faucet UI
 * uses it as the USD anchor for the per-currency figures below.
 */
export const FAUCET_CLAIM_AMOUNT_USD = 1000;

/**
 * Rolling-deploy fallback for API versions that predate `cooldownSeconds` in
 * the successful claim response. The backend's configured duration remains
 * authoritative whenever it is present.
 */
export const FAUCET_COOLDOWN_FALLBACK_SECONDS = 86_400;

/**
 * Per-currency faucet grant figures (LOCAL units) — clean round numbers a user
 * of that currency recognises, shown on the pre-claim CTA / badge. Any currency
 * not listed falls back to a {1,2,5}×10ⁿ snap of `FAUCET_CLAIM_AMOUNT_USD × rate`
 * via `resolveLocalAmount`. The faucet callsites convert this figure back to
 * USDC and send it as the claim amount, so the minted tokens are worth what's
 * displayed (the backend clamps to `FAUCET_MAX_CLAIM_AMOUNT_USDC`).
 */
export const FAUCET_GRANT_BY_CURRENCY: Record<string, number> = {
  USD: 1_000,
  EUR: 1_000,
  GBP: 1_000,
  CHF: 1_000,
  CAD: 1_000,
  AUD: 1_500,
  NZD: 1_500,
  SGD: 1_000,
  AED: 5_000,
  SAR: 5_000,
  BRL: 5_000,
  PLN: 5_000,
  MYR: 5_000,
  CNY: 10_000,
  HKD: 10_000,
  SEK: 10_000,
  NOK: 10_000,
  CZK: 25_000,
  MXN: 25_000,
  ZAR: 25_000,
  TWD: 50_000,
  THB: 50_000,
  PHP: 50_000,
  TRY: 50_000,
  INR: 80_000,
  RUB: 100_000,
  JPY: 100_000,
  KRW: 1_000_000, // ALLOW-D6-LITERAL: KRW grant in whole local units, not a D6 scale
  IDR: 25_000_000, // ALLOW-D6-LITERAL: IDR grant in whole local units, not a D6 scale
  VND: 25_000_000, // ALLOW-D6-LITERAL: VND grant in whole local units, not a D6 scale
};
